import React, { useState, useEffect } from "react";

export const svg = `<svg viewBox="0 0 32 32" xmlns="http://www.w3.org/2000/svg" fill="currentColor"><path d="M21.5 2.667c-1.537.089-3.302.946-4.352 2.036-.948.992-1.696 2.465-1.391 3.891 1.671.044 3.348-.835 4.352-1.945.937-1.039 1.648-2.488 1.391-3.982zm.091 5.924c-2.412 0-3.42 1.482-5.091 1.482-1.719 0-3.29-1.388-5.37-1.388C8.301 8.686 4 11.307 4 17.482c0 5.617 5.09 11.852 7.964 11.852 1.745.017 2.168-1.097 4.536-1.109 2.371-.017 2.882 1.124 4.63 1.109 1.968-.015 3.505-2.177 4.628-3.891.805-1.227 1.136-1.853 1.76-3.24-4.631-1.173-5.552-8.641 0-10.185-1.048-1.788-4.107-3.427-5.927-3.427z"></path></svg>`;

const contentRegExp = /<svg(.*?)>(.*?)<\/svg>/s;
const attrRegExp = /(.*?)="(.*?)"/;
const splitAttrExp = /[\w-]+="[^"]*"/g;

const attributeMap = {
  viewbox: "viewBox",
  class: "className",
};

let instanceId = 0;

function Icon(props) {
  const [, attrs, content] = svg.match(contentRegExp);

  const svgAttributes = {};

  for (const stringAttr of attrs.trim().match(splitAttrExp)) {
    let [, key, value] = stringAttr.match(attrRegExp);
    if (key in attributeMap) key = attributeMap[key];
    svgAttributes[key] = value;
  }

  const [obj, setObj] = useState({ svgAttributes, __html: content });

  // On the client, unique IDs are necessary per instance.
  // We will use the fact that React SSR does not run effects!
  useEffect(() => {
    const ids = svg.matchAll(/id="(.*?)"/gm);
    let html = obj.__html;

    for (const [match, id] of ids) {
      const uniqueID = `${id}-${instanceId}`;
      html = html
        .replace(match, 'id="' + uniqueID + '"')
        .replaceAll(`url(#${id})`, `url(#${uniqueID})`)
        .replaceAll(`"#${id}"`, `"#${uniqueID}"`);
    }

    setObj({ svgAttributes, __html: html });

    instanceId++;
  }, []);

  return (
    <svg
      dangerouslySetInnerHTML={obj}
      {...obj.svgAttributes}
      {...props}
    />
  );
}

export default Object.assign(Icon, { svg });
